
    import { defineComponent } from 'vue';
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';

    export default defineComponent({
        name: 'ProductCardsSelector',
        props: {
            productCardsSelector: {
                type: Object as () => TitleAndPromotionsDetails,
                required: true,
            }
        },
        data() {
            return {
                productTypes: [
                    {
                        code: "",
                        productDescription: "",
                        hasProductNoteValue: false,
                        notes: null,
                        category:null,
                    }
                ],
                productsValue: null,
                productDescription: null,
                checkValid: true,
                productDataJson: null,
                isNextTriggered: false, //BANDERA --> si ya paso por aca o fue disparado
                isNavigationAllowed: true, //Esta permitido navegar
                getProductDescription:null
            }
        },
        methods: {
            setProductData(data) {
                this.productTypes = { ...data };
            },

            getDataProductBack(data) {
                this.productDescription = data.productDescription;
            },


            onSelectedProduct(productDescription, code, planNote,category) {
                this.productDescription = productDescription;

                //Banderas para que no sean redundante los $emits y los pasos por las vistas mediante route
                if (this.isNextTriggered || !this.isNavigationAllowed) return;  // Si ya fue disparado o no está permitido navegar
                this.isNextTriggered = true; // Marca que el evento ya fue disparado

                setTimeout(() => {
                    NF.UI.Page.block();
                    this.checkValid = true;
                    var productValueData = {
                        productDescription: productDescription,
                        code: code,
                        planNote: planNote,
                        categoryId: category,
                        fromTab: this.productCardsSelector.tabName,
                    }
                    this.Bus.$emit('SaveProductDataValueSession', productValueData);
                    this.Bus.$emit('Next', { fromTab: this.productCardsSelector.tabName });
                    this.isNavigationAllowed = false;
                }, 300)
            },

            resetNavigationFlag() {
                this.isNavigationAllowed = true;  // Permitimos la navegación nuevamente
                this.isNextTriggered = false;  // Reiniciamos la bandera
            }
        },
    })
